import { Chart } from "chart.js";

// Canvas text does not inherit the document's CSS font family.
Chart.defaults.font.family = '"Vazirmatn", Tahoma, sans-serif';

// Canvas needs a redraw when a webfont finishes loading after its first paint.
if (typeof document !== "undefined" && document.fonts) {
  const redrawCharts = () => Object.values(Chart.instances).forEach((chart) => chart.update("none"));
  document.fonts.ready.then(redrawCharts);
  document.fonts.addEventListener("loadingdone", redrawCharts);
}
